import { Component, OnInit, ViewChild } from '@angular/core';
import { PedidoCompra, PedidoCompraItem, defaultPedidoCompra, defaultPedidoCompraItem } from '../interface/pedido-compra';
import { ActivatedRoute, Router } from '@angular/router';
import { PedidoCompraService } from '../service/pedido-compra.service';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoDynamicFormField, PoLookupColumn, PoLookupComponent, PoModalComponent, PoNotificationService, PoSearchFilterMode, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { FornecedorLookupService } from 'src/app/service/fornecedor-lookup-service';
import { UsuarioLookupService } from 'src/app/service/usuario-lookup-service';
import { FornecedorCurto } from 'src/app/interface/fornecedor';
import { AuthService } from 'src/app/service/auth.service';
import { UsuarioBase } from 'src/app/interface/usuario';
import { NgForm } from '@angular/forms';
import { UtilService } from 'src/app/service/util';
import { defaultFiltroProdutoLista, FiltroProdutoLista, Produto } from 'src/app/interface/produto';
import { CentroCustoLookupService } from 'src/app/service/centro-custo-lookup-service';
import { ArmazemLookupService } from 'src/app/service/armazem-lookup-service';
import { ContaContabilLookupService } from 'src/app/service/conta-contabil-lookup-service';
import { CondicaoPagamentoLookupService } from 'src/app/service/condicao-pagamento-lookup-service';
import { TesLookupService } from 'src/app/service/tes-service';
import { EstimativaNegociacaoLookupService } from 'src/app/service/estimativa-negociacao-lookup-service';
import { SolicitacaoCompraService } from '../../solicitacao-compra/service/solicitacao-compra.service';
import { SolicitacaoCompraPendenteSolicitacao } from '../../solicitacao-compra/interface/solicitacao-compra';
import { FazendaLookupService } from 'src/app/service/fazenda-lookup-service';
import { Fazenda } from 'src/app/interface/fazenda';
import { environment } from 'src/environments/environment';
import { EstimativaNegociacaoService } from 'src/app/service/estimativa-negociacao-service';
import { EstimativaNegociacao, defaultEstimativaNegociacao } from 'src/app/interface/estimativa-negociacao';
import { FiltroListaEstimativaNegociacao } from 'src/app/filter/filtro-lista-estimativa-negociacao';
import { ProdutoService } from 'src/app/service/produto-service';
import { ProdutoLookupService } from 'src/app/service/produto-lookup-service';

@Component({
  selector: 'app-pedido-compra-crud',
  templateUrl: './pedido-compra-crud.component.html',
  styleUrl: './pedido-compra-crud.component.css'
})
export class PedidoCompraCrudComponent implements OnInit {

  pedidoCompra: PedidoCompra = defaultPedidoCompra();
  pedidoCompraItem: PedidoCompraItem = defaultPedidoCompraItem();
  pedidoCompraItemOriginal: PedidoCompraItem = defaultPedidoCompraItem();
  estimativaNegociacao: EstimativaNegociacao = defaultEstimativaNegociacao();

  tabelaSolicitacaoCompraItens: Array<SolicitacaoCompraPendenteSolicitacao> = [];

  tabelaEstimativaNegociacaoItens: Array<EstimativaNegociacao> = [];
  tabelaEstimativaNegociacaoFiltro: FiltroListaEstimativaNegociacao;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  bloqueiaEdicao: boolean = false;
  fornecedorCodigoLoja: string = '';
  tesPadrao: string = '';
  valorTotal: number =0;

  produtoItems: Array<Produto> = []
  filterZC1 = {CZC1CODZC0: '', combobox: 'S'};
  filterZC2 = {CZC2CODZC1: '', combobox: 'S'};
  filterPDMCombo = {CPDM: '', combobox: 'S'};
  produtosShowMoreDisable: boolean = true;

  usuarioColumnsFilters: Array<PoLookupColumn> = this.usuarioLookupService.getColumnsFilter();
  fornecedorColumnsFilters: Array<PoLookupColumn> = this.fornecedorLookupService.getColumnsFilter();
  centroCustoColumnsFilters: Array<PoLookupColumn> = this.centroCustoLookupService.getColumnsFilter();
  produtoColumnsFilters: Array<PoLookupColumn> = this.produtoLookupService.getColumnsFilter();
  contaContabilColumnsFilters: Array<PoLookupColumn> = this.contaContabilLookupService.getColumnsFilter();
  armazemColumnsFilters: Array<PoLookupColumn> = this.armazemLookupService.getColumnsFilter();
  condicaoPagamentoColumnsFilters: Array<PoLookupColumn> = this.condicaoPagamentoLookupService.getColumnsFilter();
  tesColumnsFilters: Array<PoLookupColumn> = this.tesLookupService.getColumnsFilter();
  estimativaNegociacaoColumnsFilters: Array<PoLookupColumn> = this.estimativaNegociacaoLookupService.getColumnsFilter();
  fazendaColumnsFilters: Array<PoLookupColumn> = this.fazendaLookupService.getColumnsFilter();

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  urlApiProtheus: string = environment.urlApiProtheus;

  filtroProdutoLista: FiltroProdutoLista = defaultFiltroProdutoLista();

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Lista', action: this.goLista.bind(this)},
      {label: 'Pedido de Compra'},
    ],
  };

  constructor(
    private activateRoute: ActivatedRoute,
    private router: Router,
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
    private authService: AuthService,
    private utilService: UtilService,
    private pedidoCompraServices: PedidoCompraService,
    private solicitacaoCompraServices: SolicitacaoCompraService,
    public usuarioLookupService: UsuarioLookupService,
    public fornecedorLookupService: FornecedorLookupService,
    public produtoService: ProdutoService,
    public centroCustoLookupService: CentroCustoLookupService,
    public contaContabilLookupService: ContaContabilLookupService,
    public armazemLookupService: ArmazemLookupService,
    public condicaoPagamentoLookupService: CondicaoPagamentoLookupService,
    public tesLookupService: TesLookupService,
    public estimativaNegociacaoLookupService: EstimativaNegociacaoLookupService,
    public estimativaNegociacaoService: EstimativaNegociacaoService,
    public fazendaLookupService: FazendaLookupService,
    public produtoLookupService: ProdutoLookupService,
  ){
    this.tabelaEstimativaNegociacaoFiltro = new FiltroListaEstimativaNegociacao(authService,'filtro-lista-pc-estimativa-negocicaco');
  }

  @ViewChild( 'formPrincipal' , { static: true }) formPrincipal!: NgForm;
  @ViewChild( 'formItem' , { static: true }) formItem!: NgForm;
  @ViewChild( 'formEstimativaNegociacao' , { static: true }) formEstimativaNegociacao!: NgForm;
  @ViewChild( 'modalItem' , { static: true }) modalItem!: PoModalComponent;
  @ViewChild( 'modalSolicitacaoCompra' , { static: true }) modalSolicitacaoCompra!: PoModalComponent;
  @ViewChild( 'modalProduto' , { static: true }) modalProduto!: PoModalComponent;
  @ViewChild( 'modalEstimativaNegociacao' , { static: true }) modalEstimativaNegociacao!: PoModalComponent;
  @ViewChild( 'modalEstimativaNegociacaoLista' , { static: true }) modalEstimativaNegociacaoLista!: PoModalComponent;

  async ngOnInit(){

    this.tabelaEstimativaNegociacaoFiltro.init().then(()=>{

      this.activateRoute.params.subscribe(async (params) => {
        if ('CC7NUM' in params) {
          this.loadDados(params['CC7NUM']);
        } else {
          this.pedidoCompra.DC7EMISSAO = new Date();
          this.pedidoCompra.CC7USER = (await this.authService.getUsuarioSessao()).CUSRID
        }
      })
    });

  }

  loadDados(CC7NUM: string):void{

    this.pedidoCompraServices.getPedidoCompra(CC7NUM, {CSHOEDESCRICAO: 'S'}).subscribe({
      next: (pedido) => {

        this.pedidoCompra = pedido;
        this.fornecedorCodigoLoja = this.pedidoCompra.CC7FORNECE+this.pedidoCompra.CC7LOJA;

        if (this.pedidoCompra.items.filter(item=>item.NC7QUJE > 0).length > 0){
          this.bloqueiaEdicao = true;
        }
        this.calcularTotalPedidoCompra();
      }
    })

  }

  fornecedorSelecionado(fornecedor: FornecedorCurto){
    this.pedidoCompra.CC7FORNECE = fornecedor.CA2COD;
    this.pedidoCompra.CC7LOJA = fornecedor.CA2LOJA;
  }

  usuarioSelecionado(usuario: UsuarioBase){
    this.pedidoCompra.CC7SOLICIT = usuario.CUSRCODIGO;
  }

  adicionarItem():void {

    this.pedidoCompraItemOriginal = defaultPedidoCompraItem();

    this.pedidoCompraItem = defaultPedidoCompraItem();
    this.pedidoCompraItem.CC7ITEM = this.utilService.getUniqueId(2);
    this.pedidoCompraItem.DC7DATPRF = new Date();
    this.pedidoCompraItem.DC7DATPRF.setDate(this.pedidoCompraItem.DC7DATPRF.getDate() + 30);
    this.pedidoCompraItem.CC7TES = this.tesPadrao;
    this.modalItem.open();

  }

  editarItem(row: PedidoCompraItem):void {

    this.pedidoCompraItem = {...row};
    this.pedidoCompraItemOriginal = {...row};

    this.modalItem.open();
  }

  editarItemDisabled(row: PedidoCompraItem):boolean {
    return this.bloqueiaEdicao;
  }

  confirmarItem():void{

    if (this.formItem.valid){
      let pos = this.pedidoCompra.items.findIndex( e=> e.CC7ITEM === this.pedidoCompraItem.CC7ITEM );

      if (pos >= 0){
        this.pedidoCompra.items[pos] = this.pedidoCompraItem;
      } else {
        this.pedidoCompra.items.push(this.pedidoCompraItem);
      }

      this.pedidoCompra.items = [...this.pedidoCompra.items];

      this.modalItem.close();
      this.calcularTotalPedidoCompra();
    } else {
      this.utilService.showErrosFomulario(this.formItem,document);
    }
  }

  excluirItem(row: PedidoCompraItem):void{
    this.poDialogService.confirm({
      title: 'Excluir Item',
      message: 'Deseja excluir o item?',
      confirm: () => {
        this.pedidoCompra.items = this.pedidoCompra.items.filter(e=> e.CC7ITEM !== row.CC7ITEM);
        this.calcularTotalPedidoCompra()
      }
    })
  }

  produtoSelecionado(produto: Produto):void{

    if (this.pedidoCompraItem.CC7PRODUTO !== this.pedidoCompraItemOriginal.CC7PRODUTO){

      this.pedidoCompraItem.CB1DESC = produto.CB1DESC;
      this.pedidoCompraItem.CC7DESCRI = produto.CB1DESC;
      this.pedidoCompraItem.CC7UM = produto.CB1UM;
      this.pedidoCompraItem.CC7SEGUM = produto.CB1SEGUM;
      this.pedidoCompraItem.CC7LOCAL = produto.CB1LOCPAD;
      this.pedidoCompraItem.CC7CONTA = produto.CB1CONTA;

      this.pedidoCompraItemOriginal.CC7PRODUTO = this.pedidoCompraItem.CC7PRODUTO;
    }
  }

  calcularTotalItem():void{
    this.pedidoCompraItem.NC7TOTAL = this.utilService.round(this.pedidoCompraItem.NC7PRECO * this.pedidoCompraItem.NC7QUANT,2);
  }

  calcularTotalPedidoCompra():void{
    this.valorTotal = 0;
    this.pedidoCompra.items.forEach(item =>{
      this.valorTotal += item.NC7TOTAL;
    })
  }

  confirmarPedido():void{
    if (this.formPrincipal.valid){
      if (this.pedidoCompra.items.length > 0){
        this.poDialogService.confirm({
          title: 'Gravar Pedido de Compra',
          message: 'Deseja gravar a pedido de compra?',
          confirm: () => {
            this.pedidoCompraServices.postPedidoCompra(this.pedidoCompra).subscribe({
              next: (ret) => {
                this.goLista()
              }
            })
          }
        })
      } else {
        this.poNotificationService.warning({
          message: 'Nenhum item foi informado. Informe ao menos um produto para ser comprado.',
          duration: 5000,
        })
      }
    } else {
      this.utilService.showErrosFomulario(this.formPrincipal,document);
    }
  }

  solicitacaoCompraModalOpen():void{
    let filtro = {
      CC1FORNECELOJA: this.fornecedorCodigoLoja,
      order: "C1_NUM DESC, C1_ITEM"
    }
    this.solicitacaoCompraServices.getSolicitacaoCompraPendenteLista(filtro).subscribe({
      next: (lista) =>{
        this.tabelaSolicitacaoCompraItens = lista.items;
        this.modalSolicitacaoCompra.open()
      }
    })
  }

  atualizaProduto(): void {
    this.produtoService.getProduto(this.pedidoCompraItem.CC7PRODUTO).subscribe({
      next: (item) => {
        this.produtoSelecionado(item);
      }
      ,error: () => {
        this.pedidoCompraItem.CC7PRODUTO = "";
      }
    });
  }

  produtoModalOpen(): void{
    this.modalProduto.open();
  }

  buscarProduto(zerarPaginacao: boolean): void {
    if (zerarPaginacao){
      this.filtroProdutoLista.page = 1;
      this.produtoItems = [];
    } else {
      this.filtroProdutoLista.page++;
    }
    this.produtoService.getProdutoLista(this.filtroProdutoLista).subscribe({
      next: (lista) =>{
        this.produtosShowMoreDisable = !lista.hasNext;
        this.produtoItems = this.produtoItems.concat(lista.items);
      }
    });
  }

  confirmarSelecaoProduto(): void {
    this.produtoItems.map((item) => {
      if (item.$selected) {
        this.pedidoCompraItem.CC7PRODUTO = item.CB1COD;
        this.produtoSelecionado(item);
      }
    })
    this.modalProduto.close();
  }

  onChangeNvl1() {
    this.filterZC1 = { CZC1CODZC0: this.filtroProdutoLista.CGRPNVL1, combobox: 'S' };
    this.filtroProdutoLista.CGRPNVL2 = '';
    this.filtroProdutoLista.CB1XPDM = '';
  }

  onChangeNvl2() {
    this.filterZC2 = { CZC2CODZC1: this.filtroProdutoLista.CGRPNVL2, combobox: 'S' };
    this.filtroProdutoLista.CB1XPDM = '';
  }

  onChangePDM() {
    this.filterPDMCombo = { CPDM: this.filtroProdutoLista.CB1XPDM, combobox: 'S' };
    this.filtroProdutoLista.CB1POSIPI = '';
  }

  selectLinha(row: SolicitacaoCompraPendenteSolicitacao):void{
    row.items.forEach(e => e.$selected = row.$selected);
  }

  confirmarSolicitacaoCompra():void{

    if (this.pedidoCompra.items.length > 0){
      this.poDialogService.confirm({
        title: 'Confirmar',
        message: 'Existem itens informados no pedido de compra. Deseja subistitur os itens pelo(s) item(ns) selecionado(s)',
        confirm: () =>{
          this.loadItemPelaSolicitacao();
          this.modalSolicitacaoCompra.close();
        }
      })
    } else {
      this.loadItemPelaSolicitacao();
      this.modalSolicitacaoCompra.close();
    }
  }

  loadItemPelaSolicitacao():void{
    this.pedidoCompra.items = [];
    this.tabelaSolicitacaoCompraItens.forEach(sc => {
      sc.items.forEach(i => {
        if (i.$selected){

          const itemPC: PedidoCompraItem = defaultPedidoCompraItem();

          itemPC.CC7ITEM = this.utilService.getUniqueId(2);
          itemPC.CC7PRODUTO = i.CC1PRODUTO;
          itemPC.CB1DESC = i.CB1DESC;
          itemPC.CC7DESCRI = i.CC1DESCRI;
          itemPC.CC7OBS = i.CC1OBS;
          itemPC.CC7UM = i.CC1UM;
          itemPC.CC7LOCAL = i.CC1LOCAL;
          itemPC.CC7CC = i.CC1CC;
          itemPC.CC7CONTA = i.CC1CONTA;
          itemPC.CC7NUMSC = sc.CC1NUM;
          itemPC.CC7ITEMSC = i.CC1ITEM;
          itemPC.NC7QUANT = i.NC1QUANT-i.NC1QUJE;
          itemPC.NC7QTDSOL = i.NC1QUANT-i.NC1QUJE;
          itemPC.DC7DATPRF =  i.DC1DATPRF;
          itemPC.CC7TES = this.tesPadrao;

          this.pedidoCompra.items.push(itemPC);
        }
      })

      this.calcularTotalPedidoCompra();

    })

    this.pedidoCompra.items = [...this.pedidoCompra.items];
  }

  estimativaNegociacaoListaModalOpen():void{
    if (this.pedidoCompraItem.CC7ZCDNEGO){
      this.tabelaEstimativaNegociacaoFiltro.dados.CZACCDNGC = this.pedidoCompraItem.CC7ZCDNEGO;
        this.estimativaNegociacaoService.getEstimativaNegociacaoLista(this.tabelaEstimativaNegociacaoFiltro.dados).subscribe({
        next: (retorno) => {
          this.tabelaEstimativaNegociacaoItens = retorno.items;
        }
      })
    }
    this.modalEstimativaNegociacaoLista.open()
  }

  tabelaEstimativaNegociacaoLoad():void{
    this.tabelaEstimativaNegociacaoItens = [];
    this.tabelaEstimativaNegociacaoFiltro.dados.page = 1;
    this.tabelaEstimativaNegociacaoFiltro.dados.pageSize = 999;
    this.estimativaNegociacaoService.getEstimativaNegociacaoLista(this.tabelaEstimativaNegociacaoFiltro.dados).subscribe({
      next: (retorno) => {
        this.tabelaEstimativaNegociacaoItens = retorno.items;
      }
    })
  }

  estimativaNegociacaoIncluir():void{
    this.estimativaNegociacao = defaultEstimativaNegociacao();
    this.modalEstimativaNegociacao.open();
  }

  estimativaNegociacaoEditar(row: EstimativaNegociacao):void{
    this.estimativaNegociacao = {...row};
    this.modalEstimativaNegociacao.open();
  }

  estimativaNegociacaoExcluir(row: EstimativaNegociacao):void{
    this.poDialogService.confirm({
      title: 'Exclusão de Estimativa de Negociação',
      message: `Deseja excluir a estimativa de negociação (${row.CZACCDNGC})?`,
      confirm: () => {
        this.estimativaNegociacaoService.deleteEstimativaNegociacao(row.CZACCDNGC).subscribe({
          next: (ret) => {
            this.tabelaEstimativaNegociacaoLoad();
          }
        })
      }
    })
  }

  fazendaSelecionada(fazenda: Fazenda):void{
    this.estimativaNegociacao.CZACDSCFAZ = fazenda.CZABDESC;
  }

  estimativaNegociacaoSelecionada(row: EstimativaNegociacao):void{
    this.pedidoCompraItem.CC7ZCDNEGO = row.CZACCDNGC;
    this.modalEstimativaNegociacaoLista.close()
  }

  confirmarEstimativaNegociacao():void{

    if (this.formEstimativaNegociacao.valid){
      this.poDialogService.confirm({
        title: 'Gravar Estimativa de Negocição',
        message: 'Deseja gravar a estimativa de negociação?',
        confirm: () => {
          this.estimativaNegociacaoService.postEstimativaNegociacao(this.estimativaNegociacao).subscribe({
            next: (ret) => {
              if (!this.estimativaNegociacao.CZACCDNGC){
                this.pedidoCompraItem.CC7ZCDNEGO = ret.CZACCDNGC;
                this.tabelaEstimativaNegociacaoItens.push(ret);
                if (! this.modalEstimativaNegociacaoLista.isHidden){
                  this.modalEstimativaNegociacaoLista.close();
                }
              } else {
                let idx = this.tabelaEstimativaNegociacaoItens.findIndex(e=> e.CZACCDNGC === ret.CZACCDNGC)
                if (idx >= 0){
                  this.tabelaEstimativaNegociacaoItens[idx] = ret;
                }

              }
              this.modalEstimativaNegociacao.close();
              this.tabelaEstimativaNegociacaoItens = [...this.tabelaEstimativaNegociacaoItens];
            }
          })
        }
      })

    } else {
      this.utilService.showErrosFomulario(this.formEstimativaNegociacao,document);
    }
  }

  public readonly tabelaItensColunas: Array<PoTableColumn> = [
    {property: 'CC7ITEM'   , label: 'Item'        , width: '08%', visible: true},
    {property: 'CC7PRODUTO', label: 'Produto'     , width: '10%', visible: true},
    {property: 'CC7DESCRI' , label: 'Descrição'   , width: '25%', visible: true},
    {property: 'CC7OBS'    , label: 'Observação'  , width: '25%', visible: true},
    {property: 'DC7DATPRF' , label: 'Necessidade' , width: '10%', visible: true , type: 'date'},
    {property: 'CC7UM'     , label: 'UM'          , width: '07%', visible: true},
    {property: 'NC7QUANT'  , label: 'Quantidade'  , width: '07%', visible: true , type: 'number', format: '1.3-3'},
    {property: 'NC7PRECO'  , label: 'Vl Unitário' , width: '07%', visible: true , type: 'number', format: '1.5-5'},
    {property: 'NC7TOTAL'  , label: 'Vl Total'    , width: '07%', visible: true , type: 'number', format: '1.2-2'},
    {property: 'CC7CC'     , label: 'Centro Custo', width: '10%', visible: true},
    {property: 'CC7CONTA'  , label: 'Cta Ctb'     , width: '10%', visible: true},
  ]

  public readonly produtoColunas: Array<PoTableColumn> = [
    { property: 'CB1COD',     visible: true,  label: 'Código'           },
    { property: 'CB1DESC',    visible: true,  label: 'Descrição'        },
    { property: 'CB1XDESCL',  visible: true,  label: 'Descrição Longa'  },
    { property: 'CB1POSIPI',  visible: true,  label: 'NCM'              },
  ]

  public readonly tabelaSolicitacaCompraActions: Array<PoTableAction> = [
    {label: 'Editar' , action: this.editarItem.bind(this),  icon: 'po-icon-edit'  , disabled: this.editarItemDisabled.bind(this)},
    {label: 'Excluir', action: this.excluirItem.bind(this), icon: 'po-icon-delete', disabled: this.editarItemDisabled.bind(this)},
  ]

  public readonly tabelaEstimativaNegociacaoActions: Array<PoTableAction> = [
    {label: 'Editar' , action: this.estimativaNegociacaoEditar.bind(this),  icon: 'po-icon-edit'  },
    {label: 'Excluir', action: this.estimativaNegociacaoExcluir.bind(this), icon: 'po-icon-delete'},
  ]

  public readonly tabelaEstimativaNegociacaoColunas: Array<PoTableColumn> = [
    {property: 'CZACCDNGC' , label: 'Código'        , width: '10%', visible: true},
    {property: 'CZACFAZEND', label: 'Fazenda'       , width: '10%', visible: true},
    {property: 'CZACDSCFAZ', label: 'Nome fazenda'  , width: '20%', visible: true},
    {property: 'CZACCLTORA', label: 'Classe da Tora', width: '10%', visible: true, type: 'label',
      labels: [
        {value: '1', label: 'Tora Grossa'           , color: 'color-01'},
        {value: '2', label: 'Tora Fina'             , color: 'color-04'},
        {value: '3', label: 'Tora Grossa (35 acima)', color: 'color-07'},
        {value: '4', label: 'Processo'              , color: 'color-10'},
        {value: '5', label: 'Refugo'                , color: 'color-12'},
      ]
    },
    {property: 'DZACDTINI' , label: 'Início'        , width: '10%', visible: true, type: 'date'},
    {property: 'DZACDTFIM' , label: 'Término'       , width: '10%', visible: true, type: 'date'},
  ]

  public readonly tabelaSolicitacaCompraColunas: Array<PoTableColumn> = [
    {property: 'CC1NUM'    , label: 'Código'         , width: '10%', visible: true},
    {property: 'CC1SOLICIT', label: 'Solicitante'    , width: '10%', visible: true},
    {property: 'DC1EMISSAO', label: 'Emissão'        , width: '10%', visible: true , type: 'date'},
    {property: 'CC1FORNECE', label: 'Fornecedor'     , width: '10%', visible: true},
    {property: 'CA2NOME'   , label: 'Razão Social'   , width: '30%', visible: true},
    {property: "items"     , label: '...', type: 'detail',
      detail: {
        columns: [
          {property: 'CC1ITEM'   , label: 'Item'},
          {property: 'CC1PRODUTO', label: 'Produto'},
          {property: 'CB1DESC'   , label: 'Descrição'},
          {property: 'CC1DESCRI' , label: 'Descrição'},
          {property: 'CC1UM'     , label: 'UM'},
          {property: 'NC1QUANT'  , label: 'Quantidade'     , type: 'number', format: '1.4-4'},
          {property: 'NC1QUJE'   , label: 'Qtd Já Entregue', type: 'number', format: '1.4-4'},
          {property: 'CC1CC'     , label: 'Centro Custo'},
          {property: 'CC1CONTA'  , label: 'Cta Ctb'},
          {property: 'CC1OBS'    , label: 'Observação'},
          {property: 'DC1DATPRF' , label: 'Necessidade'    , type: 'date'},
        ],
        typeHeader: 'top',
      }
    }
  ]


  goLista(): void {
    this.router.navigateByUrl('compras/pedido-compra/lista');
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }
}
